import { Types } from "../actions/actionTypes";

const initialState = {
    alarmData: {}
}

export const alarmDataReducer = (state = initialState, action) => {

    switch (action.type) {
        case Types.ALARM_DATA: {
            let bedId = action.payload.bedId;
            let deviceId = action.payload.deviceId;
            let dongleId = action.payload.dongleId;
            let deviceType = action.payload.deviceType;
            let newAlarms = action.payload.alarms || [];

            if (!bedId || !deviceId || !newAlarms) return;
            let alarmData = state.alarmData;

            let alarms = (state.alarmData && state.alarmData[bedId] && state.alarmData[bedId].alarms) || [];

            // for newAlarm, if not exist, push data
            alarms.unshift(...newAlarms);

            if (alarms.length > 20) alarms.splice(20);

            alarmData[bedId] = {
                ...alarmData[bedId],
                dongleId: dongleId,
                bedId: bedId,
                alarms: alarms
            }

            return {
                ...state,
                alarmData: { ...alarmData }
            }
        }
        case Types.CLEAR_ALARM:
            return {
                ...state,
                alarmData: {}
            }
        default:
            return state;
    }
}